import { FirebaseConfig } from "@/interfaces/customTypes/configProperties";
import { syncProjectFileUploaderContext } from "./projectFileUploader";
import { SocialCoachSession } from "@/services/bedrock";

export function syncUtilitiesContext(session: SocialCoachSession | undefined, firebaseConfig: FirebaseConfig) {
  syncProjectFileUploaderContext(session, firebaseConfig);
}
